/* @ngInject */
const scrappingExcel = (
  excelUtils,
  excelStyles,
  constants,
  wagonFields,
  axletreeFields,
  types
) => {
  const self = {}

  const positions = constants.arrays.positions
  const FIRST_BODY_ROW_INDEX = 7

  self.generate = (sale, options) => {
    return excelUtils.getWorkbook('axletreesCertificate')
      .then((workbook) => {
        const sheet = workbook.sheet(0)
        self.setBody(sheet, sale.wagons, options)
        self.setHeader(sheet,
          sale.number,
          sale.wagons.length,
          sale.wagons.reduce((acc, w) => acc + (w.axletrees.length || 0), 0)
        )
        return workbook.outputAsync({
          type: '',
        })
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.download = (sale, options) => {
    return self.generate(sale, options)
      .then((blob) => {
        excelUtils.downloadWorkbook(blob, 'Relevé d\'essieux')
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.setBody = (sheet, wagons, options) => {
    for (let i = 0; i < wagons.length; i++) {
      const wagon = wagons[i]
      self.setWagon(sheet, FIRST_BODY_ROW_INDEX + (i * 9), wagon, options)
    }
  }

  self.setHeader = (sheet, saleNumber, wagonCount, axletreeCount) => {
    let cell

    const wholeSheet = sheet.usedRange().value()
    const colIndex = excelUtils.getColumnName(wholeSheet[0].length)
    const rowIndex = wholeSheet.length
    const firstCellName = 'A7'
    const lastCellName = colIndex + rowIndex
    const bodyRangeName = firstCellName + ':' + lastCellName

    cell = excelUtils.getCell(sheet, 3, 3)
    cell.formula('="Essieux restitués : " & COUNTIF(' + bodyRangeName + ', "restitué")')

    cell = excelUtils.getCell(sheet, 5, 3)
    cell.formula('="Essieux ferraillés : " & COUNTIF(' + bodyRangeName + ', "ferraillé")')

    cell = excelUtils.getCell(sheet, 1, 5)
    cell.style('wrapText', true)
    excelUtils.setCellValue(cell, `RELEVÉ ESSIEUX ${saleNumber}`)

    cell = excelUtils.getCell(sheet, 4, 5)
    cell.style('wrapText', true)
    excelUtils.setCellValue(cell, `Concerne ${wagonCount} wagons pour ${axletreeCount} essieux`)
  }

  self.setTemplate = (sheet, rowIndex, options) => {
    let cell
    let colIndex = 0

    for (let index = 0; index < 8; index++) {
      sheet.row(rowIndex + index).height(16)
    }

    cell = excelUtils.getCell(sheet, rowIndex, colIndex)
    excelUtils.setCellValue(cell, 'N° du wagon')
    excelUtils.getRange(sheet, rowIndex, colIndex, 0, 1)
      .merged(true)
      .style(excelStyles.borderedCell('C5D9F1'))

    colIndex = 2
    for (let index = 0; index < 4; index++) {
      const position = positions[index]

      cell = excelUtils.getCell(sheet, rowIndex, colIndex)
      excelUtils.setCellValue(cell, 'N° essieu ' + position)
      excelUtils.getRange(sheet, rowIndex, colIndex, 0, 1)
        .merged(true)
        .style(excelStyles.borderedCell('C5D9F1'))

      excelUtils.getRange(sheet, rowIndex + 1, colIndex, 0, 1)
        .merged(true)
        .style(excelStyles.borderedCell())

      cell = excelUtils.getCell(sheet, rowIndex + 2, colIndex)
      excelUtils.setCellValue(cell, 'Type')
      cell.style(excelStyles.borderedCell('C5D9F1'))
      cell = excelUtils.getCell(sheet, rowIndex + 3, colIndex)
      cell.style(excelStyles.borderedCell())

      if (options.export === 'diameter') {
        cell = excelUtils.getCell(sheet, rowIndex + 2, colIndex + 1)
        excelUtils.setCellValue(cell, 'Diamètre')
        cell.style(excelStyles.borderedCell('C5D9F1'))
        cell = excelUtils.getCell(sheet, rowIndex + 3, colIndex + 1)
        cell.style(excelStyles.borderedCell())
      } else {
        cell = excelUtils.getCell(sheet, rowIndex + 2, colIndex + 1)
        excelUtils.setCellValue(cell, 'Mesure')
        cell.style(excelStyles.borderedCell('C5D9F1'))
        cell = excelUtils.getCell(sheet, rowIndex + 3, colIndex + 1)
        cell.style(excelStyles.borderedCell())
      }

      cell = excelUtils.getCell(sheet, rowIndex + 4, colIndex)
      excelUtils.setCellValue(cell, 'Lieu')
      cell.style(excelStyles.borderedCell('C5D9F1'))
      cell = excelUtils.getCell(sheet, rowIndex + 5, colIndex)
      cell.style(excelStyles.borderedCell())

      cell = excelUtils.getCell(sheet, rowIndex + 4, colIndex + 1)
      excelUtils.setCellValue(cell, 'Date')
      cell.style(excelStyles.borderedCell('C5D9F1'))
      cell = excelUtils.getCell(sheet, rowIndex + 5, colIndex + 1)
      cell.style(excelStyles.borderedCell())

      cell = excelUtils.getCell(sheet, rowIndex + 6, colIndex)
      excelUtils.setCellValue(cell, 'Décision')
      excelUtils.getRange(sheet, rowIndex + 6, colIndex, 0, 1)
        .merged(true)
        .style(excelStyles.borderedCell('C5D9F1'))

      excelUtils.getRange(sheet, rowIndex + 7, colIndex, 0, 1)
        .merged(true)
        .style(excelStyles.borderedCell())

      colIndex += 2
    }
  }

  self.setWagon = (sheet, rowIndex, wagon, options) => {
    self.setTemplate(sheet, rowIndex, options)
    self.setWagonData(sheet, rowIndex, wagon)
    self.setAxletreesData(sheet, rowIndex, wagon.axletrees, options)
  }

  self.setWagonData = (sheet, rowIndex, wagon) => {
    const cell = excelUtils.getCell(sheet, rowIndex + 1, 0)
    excelUtils.setCellValue(cell, wagon.id, wagonFields['id'].type)
    excelUtils.getRange(sheet, rowIndex + 1, 0, 0, 1)
      .merged(true)
      .style(excelStyles.borderedCell())
  }

  self.setAxletreesData = (sheet, rowIndex, axletrees, options) => {
    let colIndex
    for (let index = 0; index < axletrees.length; index++) {
      const axletree = axletrees[index]
      let i = 0
      while (axletree.position !== positions[i] && i < 4) {
        i++
      }
      colIndex = 2 + 2 * i
      self.setAxletree(sheet, rowIndex, colIndex, axletree, options)
    }
  }

  self.setAxletree = (sheet, rowIndex, colIndex, axletree, options) => {
    let cell

    cell = excelUtils.getCell(sheet, rowIndex + 1, colIndex)
    excelUtils.setCellValue(cell, axletree.number, axletreeFields.number.type)

    cell = excelUtils.getCell(sheet, rowIndex + 3, colIndex)
    excelUtils.setCellValue(cell, axletree.type, axletreeFields.type.type)

    if (options.export === 'diameter') {
      cell = excelUtils.getCell(sheet, rowIndex + 3, colIndex + 1)
      excelUtils.setCellValue(cell, axletree.diameter, axletreeFields.diameter.type)
    } else {
      cell = excelUtils.getCell(sheet, rowIndex + 3, colIndex + 1)
      excelUtils.setCellValue(cell, axletree.material, axletreeFields.material.type)
    }

    cell = excelUtils.getCell(sheet, rowIndex + 5, colIndex)
    excelUtils.setCellValue(cell, axletree.expeditionPlace, axletreeFields.expeditionPlace.type)
    cell.style({
      fontSize: 10,
    })

    cell = excelUtils.getCell(sheet, rowIndex + 5, colIndex + 1)
    excelUtils.setCellValue(cell, axletree.expeditionDate, axletreeFields.expeditionDate.type)
    cell.style({
      fontSize: 10,
    })

    cell = excelUtils.getCell(sheet, rowIndex + 7, colIndex)
    excelUtils.setCellValue(cell, axletree.decision, axletreeFields.decision.type)
  }

  return self
}
export default scrappingExcel



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/scrapping/scrappingExcel.service.js